import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Card, Space, Divider, Col } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;

// Componente para seleccionar la opción válida
const OptionValidaSelect = ({ form, value, onChange, ...props }) => {
  const opciones = Form.useWatch("opciones", form) || [];
  const tipoEncuesta = Form.useWatch("tipo", form);

  if (tipoEncuesta !== "multiplechoice" && tipoEncuesta !== "sino") {
    return (
      <Select
        disabled
        placeholder="Solo disponible para preguntas de opción múltiple"
        value={value}
        onChange={onChange}
        {...props}
      />
    );
  }

  if (opciones.length === 0) {
    return (
      <Select
        disabled
        placeholder="Primero agregue opciones arriba"
        value={value}
        onChange={onChange}
        {...props}
      />
    );
  }

  return (
    <Select
      placeholder="Seleccione la opción correcta"
      value={value}
      onChange={onChange}
      {...props}
    >
      {opciones.map((opcion, index) => (
        <Option key={index} value={index}>
          {index + 1}. {opcion || `Opción ${index + 1}`}
        </Option>
      ))}
    </Select>
  );
};

const FormEncuesta = ({
  dataEncuesta = {},
  setDataEncuesta = () => {},
  onSubmit = () => {},
}) => {
  const [form] = Form.useForm();
  const initialValues = {
    tipo: dataEncuesta.tipo || "sino",
    pregunta: dataEncuesta.pregunta || "",
    respuestaTexto: dataEncuesta.respuestaTexto || "",
    opciones: dataEncuesta.opciones || [],
    opcionValida: dataEncuesta.opcionValida || 0,
  };

  const tipoValue = Form.useWatch("tipo", form);

  useEffect(() => {
    //const subscription = form.getFieldsValue();
    const tipoActual = form.getFieldValue("tipo");

    if (tipoActual === "sino") {
      // Para Form.List, necesitas usar setFieldsValue con la estructura correcta
      form.setFieldsValue({
        opciones: ["Sí", "No"],
        opcionValida: undefined, // Reset de la opción válida
      });
    } else if (tipoActual === "multiplechoice") {
      // Limpiar opciones si cambias a multiple choice
      const opcionesActuales = form.getFieldValue("opciones") || [];
      if (
        opcionesActuales.length === 2 &&
        opcionesActuales[0] === "Sí" &&
        opcionesActuales[1] === "No"
      ) {
        form.setFieldsValue({
          opciones: [],
          opcionValida: undefined,
        });
      }
    }
  }, [form]);

  useEffect(() => {
    console.log(
      "%c FormEncuesta recibió nuevos datos:",
      "color: cyan",
      dataEncuesta
    );

    // Actualizar el formulario con los nuevos datos
    form.setFieldsValue({
      tipo: dataEncuesta.tipo || "sino",
      pregunta: dataEncuesta.pregunta || "",
      respuestaTexto: dataEncuesta.respuestaTexto || "",
      opciones: dataEncuesta.opciones || [],
      opcionValida: dataEncuesta.opcionValida || 0,
    });

    console.log(
      "%c Formulario actualizado con:",
      "color: cyan",
      form.getFieldsValue()
    );
  }, [dataEncuesta, form]);

  useEffect(() => {
    if (tipoValue === "sino") {
      form.setFieldsValue({
        opciones: ["Sí", "No"],
        opcionValida: undefined,
      });
    }
  }, [tipoValue, form]);

  useEffect(() => {
    form.setFieldsValue({
      tipo: dataEncuesta.tipo || "sino",
      pregunta: dataEncuesta.pregunta || "",
      respuestaTexto: dataEncuesta.respuestaTexto || "",
      opciones: dataEncuesta.opciones || [],
      opcionValida: dataEncuesta.opcionValida || 0,
    });
  }, [dataEncuesta, form]); //

  const handleFormChange = (changedValues, allValues) => {
    console.log("Valores cambiados:", changedValues);
    console.log("Todos los valores:", allValues);
    // setData(allValues);
    // setDataEncuesta(allValues);
  };

  const handleSubmit = (values) => {
    console.log("%c Datos de encuesta:", "color: yellow", values);

    // Actualizar el estado del padre
    // setDataEncuesta(prevEncuesta => ({
    //   ...prevEncuesta,
    //   ...values // Merge todos los valores del formulario
    // }));
    setDataEncuesta(values);

    // Llamar onSubmit si se proporciona
    onSubmit(values);
  };

  const tiposEncuesta = [
    { value: "sino", label: "Sí/No" },
    { value: "multiplechoice", label: "Opción múltiple" },
  ];

  return (
    <div style={{ padding: "20px 0px" }}>
      <Card title="Pregunta" style={{ width: "100%" }}>
        <Form
          form={form}
          maxWidth={900}
          layout="vertical"
          initialValues={initialValues}
          onValuesChange={handleFormChange}
          onFinish={handleSubmit}
        >
          {/* <Row gutter={16}> */}
          <Col style={{ width: "100%" }}>
            <Form.Item
              name="tipo"
              label="Tipo"
              rules={[
                { required: true, message: "Seleccione el tipo de encuesta" },
              ]}
            >
              <Select placeholder="Seleccione el tipo">
                {tiposEncuesta.map((tipo) => (
                  <Option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="pregunta"
              label="Pregunta"
              rules={[{ required: true, message: "Ingrese la pregunta" }]}
            >
              <TextArea
                rows={3}
                placeholder="Escriba aquí la pregunta de la encuesta..."
                maxLength={500}
                showCount
              />
            </Form.Item>

            <Divider
              orientation="left"
              style={{ marginTop: 10, marginBottom: 8 }}
            >
              Opciones
            </Divider>
            <Form.List name="opciones" label="Opciones">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    return (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: 8,
                        }}
                      >
                        <span style={{ marginRight: 8, minWidth: "30px" }}>
                          {name + 1}.
                        </span>
                        <Form.Item
                          {...restField}
                          name={[name]}
                          style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                          rules={[
                            { required: true, message: "Ingrese una opción" },
                          ]}
                        >
                          <Input
                            placeholder="Ingrese una opción"
                            disabled={tipoValue === "sino"}
                          />
                        </Form.Item>
                        <Button
                          type="text"
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                          style={{ color: "#ff4d4f" }}
                          disabled={tipoValue === "sino"}
                        />
                      </div>
                    );
                  })}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      disabled={tipoValue === "sino"}
                    >
                      Agregar Opción
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Form.Item
              name="opcionValida"
              label="Opción Válida"
              rules={[
                {
                  required: Form.useWatch("tipo", form) === "multiplechoice",
                  message: "Seleccione la opción correcta",
                },
              ]}
            >
              <OptionValidaSelect form={form} />
            </Form.Item>
            {/* </Col> */}
            {/* </Row> */}

            <Form.Item
              name="respuestaTexto"
              label="Texto de Respuesta/Feedback"
            >
              <TextArea
                rows={2}
                placeholder="Texto que se mostrará después de responder (opcional)"
                maxLength={300}
                showCount
              />
            </Form.Item>

            {/* Opciones múltiples - Solo visible cuando tipo es 'multiplechoice' */}
            {/* <Form.Item
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.tipo !== currentValues.tipo
              }
            >
              {({ getFieldValue }) => {
                const tipoValue = getFieldValue("tipo");
                return tipoValue === "multiplechoice" ? (
                  <div>
                    <Divider orientation="left">
                      <span style={{ color: "#1890ff" }}>
                        Opciones de Respuesta
                      </span>
                    </Divider>
                    <Form.List name="opciones">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }) => (
                            <Card
                              key={key}
                              size="small"
                              style={{
                                marginBottom: 8,
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              <Space
                                style={{ display: "flex", marginBottom: 8 }}
                              >
                                <Form.Item
                                  {...restField}
                                  name={name}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Ingrese el texto de la opción",
                                    },
                                  ]}
                                  style={{ marginBottom: 0, flex: 1 }}
                                >
                                  <Input
                                    placeholder={`Opción ${name + 1}`}
                                    maxLength={200}
                                  />
                                </Form.Item>
                                <Button
                                  type="text"
                                  danger
                                  icon={<MinusCircleOutlined />}
                                  onClick={() => remove(name)}
                                  title="Eliminar opción"
                                />
                              </Space>
                            </Card>
                          ))}
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Opción
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  </div>
                ) : null;
              }}
            </Form.Item> */}
          </Col>

          <Divider />

          <Form.Item>
            <Space direction="vertical">
              <Button type="primary" htmlType="submit">
                Actualizar Pregunta
              </Button>
              <Button
                onClick={() => {
                  const valoresVacios = {
                    tipo: "sino",
                    pregunta: "",
                    respuestaTexto: "",
                    opciones: [],
                    opcionValida: undefined,
                  };

                  // Actualizar el estado padre primero
                  setDataEncuesta(valoresVacios);

                  // Luego resetear el formulario (el useEffect se encargará de sincronizar)
                  //form.resetFields();
                }}
              >
                Limpiar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default FormEncuesta;
